// extracted by mini-css-extract-plugin
module.exports = {"container":"progressCard_container__3QBPz","text":"progressCard_text__LjWkg","textPadding":"progressCard_textPadding__3A7o1","image":"progressCard_image__2-7iU"};